import script from "./ChatContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContent.vue?vue&type=script&setup=true&lang=js"

import "./ChatContent.vue?vue&type=style&index=0&id=16247ddb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16247ddb"]])

export default __exports__